import { forwardRef, ForwardRefRenderFunction, Fragment, ReactNode } from 'react';

import { push } from 'connected-react-router';

import backButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/common/back_button_click';

import Button from 'bloko/blocks/button';
import { H1 } from 'bloko/blocks/header';
import BlokoLink from 'bloko/blocks/link';
import VSpacing from 'bloko/blocks/vSpacing';

import { useDispatch } from 'store/utils';

import 'components/TitlePage/TitlePage.less';

interface TitlePageProps {
    header?: string;
    subHeader?: ReactNode;
    sideButtons?: ReactNode;
    dataQa?: string;
    withChat?: boolean;
    backLink?: {
        href: string;
        text: string;
        dataQa?: string;
        historyState?: Record<string, unknown>;
    } | null;
}

const TitlePage: ForwardRefRenderFunction<HTMLDivElement, TitlePageProps> = (
    { header, subHeader, sideButtons, dataQa, backLink },
    ref
) => {
    const dispatch = useDispatch();

    return (
        <div ref={ref}>
            <VSpacing base={8} />
            {backLink && (
                <Fragment>
                    <BlokoLink
                        Element={Button}
                        onClick={() => {
                            dispatch(push(backLink.href, backLink.historyState));
                            backButtonClick();
                        }}
                        data-qa={backLink.dataQa}
                    >
                        {backLink.text}
                    </BlokoLink>
                    <VSpacing base={4} />
                </Fragment>
            )}
            <div className="title-container">
                <div>
                    <H1 data-qa={dataQa}>{header}</H1>
                    {subHeader && (
                        <>
                            <VSpacing base={2} />
                            {subHeader}
                        </>
                    )}
                </div>
                <div className="title-buttons">{sideButtons}</div>
            </div>
            <VSpacing base={8} xs={2} />
        </div>
    );
};

export default forwardRef(TitlePage);
